<template>
  <div>
    <preamble v-bind="preamble" />
    <pop v-bind="popContent" v-on:popClose="closePop" />
    <section class="main">
        <div class="container">
            <div class="columns">
                <div class="column is-2 off-mobile">
                    <div id="left-move" @click="handleTimelineMove(currentLine.id, 'left')" class="arrow" >
                        <svg viewBox="0 0 61.28 21.57"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="51.28" y="9.68" width="10" height="2" transform="translate(112.57 21.37) rotate(180)"/><rect class="cls-1" x="35.28" y="9.68" width="10" height="2" transform="translate(80.57 21.37) rotate(180)"/><rect class="cls-1" x="1.28" y="9.68" width="30" height="2" transform="translate(32.57 21.37) rotate(180)"/><rect class="cls-1" x="-1.49" y="5.01" width="15" height="2" transform="translate(14.51 6.01) rotate(135)"/><rect class="cls-1" x="-1.14" y="14.56" width="15" height="2" transform="translate(-0.14 31.06) rotate(-135)"/></g></g></svg>
                    </div>
                </div>
                <div class="column is-8">
                    <div class="columns">
                        <div id="tl-image" class="column is-7">
                            <img v-for="(itemImg, index) in timeLine" :key="index" 
                            v-bind:src="api + itemImg.image" 
                            v-bind:class="{ 'hidden': currentLine.id !== itemImg.id }"
                            v-bind:alt='itemImg.title'
                            >
                        </div>
                        <div id="tl-text" class="column is-5 ml-5">
                            <h2 id="tl-title" class="mt-5">
                                <svg class="off-mobile" viewBox="0 0 61.28 21.57"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1">
                                    <rect class="cls-1" x="51.28" y="9.68" width="10" height="2" transform="translate(112.57 21.37) rotate(180)"/>
                                    <rect class="cls-1" x="35.28" y="9.68" width="10" height="2" transform="translate(80.57 21.37) rotate(180)"/>
                                    <rect class="cls-1" x="1.28" y="9.68" width="30" height="2" transform="translate(32.57 21.37) rotate(180)"/></g></g>
                                </svg>

                                {{ currentLine.year }}.

                            </h2>
                            <h3 id="tl-sub-title" class="mt-3">{{ currentLine.title }}</h3>
                            <div v-html="currentLine.shortDescription" id="tl-body"></div>
                            <p v-if="currentLine.longDescription" class="read-more">
                                <a @click="handlePop">Read More</a>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="column is-2 off-mobile">
                    <div id="right-move" @click="handleTimelineMove(currentLine.id, 'right')" class="arrow">
                        <svg viewBox="0 0 61.28 21.57"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="51.28" y="9.68" width="10" height="2" transform="translate(112.57 21.37) rotate(180)"/><rect class="cls-1" x="35.28" y="9.68" width="10" height="2" transform="translate(80.57 21.37) rotate(180)"/><rect class="cls-1" x="1.28" y="9.68" width="30" height="2" transform="translate(32.57 21.37) rotate(180)"/><rect class="cls-1" x="-1.49" y="5.01" width="15" height="2" transform="translate(14.51 6.01) rotate(135)"/><rect class="cls-1" x="-1.14" y="14.56" width="15" height="2" transform="translate(-0.14 31.06) rotate(-135)"/></g></g></svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="columns">
                <div class="column is-8 is-offset-2">
                    <div id="timeline">
                        <ul>

                            <li v-for="(timeLineItem, index) in timeLine" :key="index" 
                              @click="handleTimelineMove(timeLineItem.id)"
                               v-bind:class="{ 'activeLine': currentLine.id === timeLineItem.id }"
                              >
                                <span class="limiter"></span>
                                <span class="limiter-half"></span>
                                {{ timeLineItem.year }}.
                            </li>

                        </ul>
                        <span id="limiter-dotted"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="columns">
                <div class="column is-8 is-offset-2">
                  <p class="disclaimer">*	This timeline has been created through stakeholders meeting and collecting memories and histories from 
          people who lived through the most dark times of the epidemic of HIV/AIDS in the country. It is a growing and fluid endeavour and if you have 
          any memories or photographs that you’d like to share please go to “Share Your Story” (hyperlink) section of this website.</p>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>
<script>
    import Preamble from '@/components/Preamble.vue'
    import Pop from '@/components/Pop.vue'
    import sharedMethodsMixin from '@/mixins/sharedMethodsMixin'
    import { resources, API } from '@/utils/constants'

    export default {
        name: "Timeline",
        mixins: [sharedMethodsMixin],
        components: {
                Preamble, Pop    
                },
        data() {
            return {
              // triggered: true,
              api: API,
              preamble: {
                title: '',
                subTitle: '',
                description: '<p>You are either infected or affected”, said Namubiru Priscilla during one of the stakeholders’ meetings, and she couldn’t have been more right about the impact that the HIV/AIDS epidemic has had on Uganda. Priscilla is one of the many who were interviewed and consulted for this undertaking of documenting the History of HIV/AIDS in Uganda. Millions of Ugandans have been infected and millions further affected by the virus. To unshackle ourselves from the burden of such profound experiences we must first look back in time. </p><p>Through the stories and materials donated to this effort, we are able to see Uganda’s journey from the unknown to the wealth of information on the virus available today. From sensitisation campaigns, to newspapers, archives, personal artefacts, music and film, we present you with a mosaic of stories to bring us closer to a better understanding of the journey of HIV/AIDS in Uganda.</p>',
                watchVideo: 'https://www.youtube.com/embed/IiCMGnWphMI',
              },
              popContent: {
                triggered: false,
                title: 'The disease now has a name: "Slim"',
                description: 'In Uganda, during the 1980’s and 1990’s behavioural change communication (BCC) campaigns were effective in reducing the spread of HIV. Many younger people may be complacent about HIV as they have not lived through the times when HIV was killing thousands of people weekly before effective treatment was available.',
              },
              currentLine: {
                id: '101',
                year: '1968',
                title: '...',
                shortDescription: '',
                longDescription: '', // will come back to this
                image: '' // will come back to this
              },
              timeLine : [
                {
                  id: '',
                  year: '',
                  title: '',
                  shortDescription: '',
                  longDescription: '', 
                  image: ''
                }
              ]
            }
        },
        created() {
          
          //Fetch timeline items 
          this.read(`${resources.timeline}`)
            .then(response => {
              this.timeLine = response.data
              this.currentLine = this.timeLine[0]
          })
        
        },
        mounted() {
            // let editorContainer = document.getElementById('timeline');
            // editorContainer.addEventListener("scroll", this.onScroll)
        },
        beforeDestroy() {
          //window.removeEventListener("scroll", this.onScroll)
        },
        methods: {
          handleTimelineMove(currentId, direction) {
            const TotalItems = this.timeLine.length;

            if(direction){
              const currentTimelineIndex = this.timeLine.findIndex(lineItem => lineItem.id === currentId);
              if(direction === 'right') {

                
                if (currentTimelineIndex >= (TotalItems - 1)){
                  this.currentLine = this.timeLine[0]
                } else {
                  this.currentLine = this.timeLine[(currentTimelineIndex + 1)]
                }
              } else {
                if (currentTimelineIndex <= 0){
                  this.currentLine = this.timeLine[(TotalItems - 1)]
                } else {
                  this.currentLine = this.timeLine[(currentTimelineIndex - 1)]
                }
              }

            } else {
              const selectedLineItem = this.timeLine.find( ({ id }) => id === currentId );
              this.currentLine = selectedLineItem
            }


            
          },

          handlePop() {
            this.popContent = { ...this.currentLine, triggered: true, video: this.popContent.video }
          },

          closePop() {
            this.popContent.triggered = false;
          },
          
        },
        computed: {
             
        },
    }
</script>

<style>
</style>
